import { createContext, createElement, useContext, useEffect, useState, type ReactNode } from "react";

type Mode = "light" | "dark";
const KEY = "azmailhub:mode:v1";

interface Ctx {
  mode: Mode;
  toggle: () => void;
}

const ModeContext = createContext<Ctx | null>(null);

export function ModeProvider({ children }: { children: ReactNode }) {
  const [mode, setMode] = useState<Mode>(() => {
    const saved = localStorage.getItem(KEY);
    if (saved === "light" || saved === "dark") return saved;
    return matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-mui-color-scheme", mode);
    localStorage.setItem(KEY, mode);
  }, [mode]);

  return createElement(
    ModeContext.Provider,
    { value: { mode, toggle: () => setMode((m) => (m === "light" ? "dark" : "light")) } },
    children,
  );
}

export function useMode(): Ctx {
  const ctx = useContext(ModeContext);
  if (!ctx) throw new Error("useMode outside provider");
  return ctx;
}
